import { render, staticRenderFns } from "./businesses.vue?vue&type=template&id=1701b2b3&scoped=true"
import script from "./businesses.vue?vue&type=script&lang=js"
export * from "./businesses.vue?vue&type=script&lang=js"
import style0 from "./businesses.vue?vue&type=style&index=0&id=1701b2b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701b2b3",
  null
  
)

export default component.exports